import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';


@Injectable({
	providedIn: 'root'
})
export class AuthService {
	constructor(private router: Router) {}

	private logoutSubject = new Subject<void>();
	logout$ = this.logoutSubject.asObservable();

	triggerLogout(): void {
		this.logoutSubject.next();
		localStorage.clear();
		localStorage.setItem('isLoggingOut', 'true');
		this.router.navigate(['/']);
	}

	hasLoggedOut(): boolean {
		// facultatif : tu peux contrôler par exemple avec un flag en mémoire
		return !localStorage.getItem('token'); // ou token etc.
	}
}
